export default {
    components: {
        emojiPicker: {
            input: {
                placeholder: {
                    stringName:
                        'txt_chayns_components_emoji_input_components_emojiPicker_input_placeholder',
                    fallback: 'Suchen',
                },
            },
        },
    },
} as const;
